// src/pages/Visualloft.js
import React from 'react';
import { API_URL } from '../config';

const Visualloft = () => {
  return (
    <div style={{ height: '100vh' }}>
      <iframe
        src={`${API_URL}/visualloft-frame`}
        style={{ width: '100%', height: '100%', border: 'none' }}
        title="Визуализация Лофта"
      />
    </div>
  );
};

export default Visualloft;